var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 80,
    viewBox: "0 0 49 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 40,
    r: 24,
    fill: "#FDDA24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0266 41.2629H25.7635V36.2103V31.1576V29.8945C25.7635 29.1985 25.1963 28.6313 24.5003 28.6313C23.8043 28.6313 23.2372 29.1985 23.2372 29.8945V31.1576V41.2629H21.974V31.1576C21.974 30.4616 21.4068 29.8945 20.7108 29.8945C20.0148 29.8945 19.4477 30.4616 19.4477 31.1576V35.9146C20.2225 36.609 20.7108 37.6169 20.7108 38.7366V41.2983C23.5492 41.6128 25.7635 44.0267 25.7635 46.9471V47.5787H24.5003V46.9471C24.5003 44.5092 22.5172 42.5261 20.0793 42.5261H19.4477V38.7366C19.4477 37.3433 18.3146 36.2103 16.9214 36.2103V43.7892C16.9214 47.969 20.3205 51.3682 24.5003 51.3682H25.7635C29.9433 51.3682 33.3424 47.969 33.3424 43.7892V34.9471C33.3424 34.2511 32.7753 33.684 32.0793 33.684C31.3833 33.684 30.8161 34.2511 30.8161 34.9471V36.2103V41.2629H29.5529V36.2103V34.9471V31.1576C29.5529 30.4616 28.9858 29.8945 28.2898 29.8945C27.5938 29.8945 27.0266 30.4616 27.0266 31.1576V36.2103V41.2629ZM18.1845 35.1636C17.7892 35.0234 17.364 34.9471 16.9214 34.9471H15.6582V43.7892C15.6582 48.665 19.6245 52.6313 24.5003 52.6313H25.7635C30.6393 52.6313 34.6056 48.665 34.6056 43.7892V34.9471C34.6056 33.5538 33.4725 32.4208 32.0793 32.4208C31.6194 32.4208 31.1879 32.5442 30.8161 32.7597V31.1576C30.8161 29.7644 29.683 28.6313 28.2898 28.6313C27.7701 28.6313 27.2867 28.7889 26.8847 29.0589C26.5391 28.0751 25.6009 27.3682 24.5003 27.3682C23.3998 27.3682 22.4616 28.0751 22.1159 29.0589C21.714 28.7889 21.2305 28.6313 20.7108 28.6313C19.3176 28.6313 18.1845 29.7644 18.1845 31.1576V35.1636Z",
    fill: "#2C2A29"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IconHand.f5a645942dc9eb5d1a5220b653346d4e.svg";